<template>
  <div class="handover_examine">
    <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.push('/qyh_config')">返回</el-button>
    <el-divider content-position="left">头部背景图片管理</el-divider>
    <div>
      <!-- <div style="margin-left:0.2rem">
        <el-popover placement="bottom-start" v-model="visible" width="500">
          <el-form :model="searchArr" ref="searchForm" label-width="100px"
            style="margin-left:-0.3rem">
            <el-form-item label="所属业务" prop="salesman_id">
              <el-select v-model="searchArr.salesman_id" placeholder="请选择财税负责人筛选" filterable
                clearable size="mini">
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username"
                  :value="user.id"></el-option>
              </el-select>
            </el-form-item> -->
      <!-- <el-form-item label="支付人/手机号" prop="payuser_id">
              <el-input v-model="searchArr.payuser_id" size="mini"
                placeholder="支付人 / 手机号"></el-input>
            </el-form-item>
            <el-form-item label="支付时间" prop="send_pay_date">
              <el-date-picker size="mini" v-model="searchArr.send_pay_date" type="datetimerange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="创建时间" prop="created_at">
              <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="text-align: right;margin-right:0.3rem">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </div> -->
      <div>
        <upfile name="上传" :many="1" action="https://weixin.qiyehuo.com/api/ysy_common_upfile"
          :up_path="{ path: 'qyh_head_bg' }" :mul="false" bus="ysy_head_bg" err_bus="ysy_head_bg_err" acc=".jpeg,.jpg,.png"
          :acce="['img']" :size_M="0.8" />
      </div>
      <div style="margin-top:0.2rem">
        <!-- <el-input ref="input" v-model="searchArr.phone_order" placeholder="名称/分类名称" size="mini"
          clearable :loading="searchLoading" prefix-icon="el-icon-search">
        </el-input> -->
        <el-select v-model="searchArr.phone_order" filterable remote reserve-keyword placeholder="图片名称" size="mini"
          clearable :remote-method="searchRemoteCfcategory" :loading="searchLoading" @change="handleSearchCfcategory"
          prefix-icon="el-icon-search">
          <el-option v-for="searchCompany in searchCategories" :key="searchCompany.id" :label="searchCompany.name"
            :value="searchCompany.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="margin-top:0.2rem;padding: 0.2rem;border-radius: 15px;border: 1px solid #909399;background-color: ">
      <HeadPic :listData="categoryData" />
    </div>
    <div class="block" style="margin-top: 10px; text-align: center">
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="npage"
        layout="sizes, total, prev, pager, next, jumper" :total="total" :page-sizes="[18, 36, 54, 72, 90]"
        :page-size="categoryPerPage" background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import HeadPic from '../PictureCom/PictureList'
import upfile from '../../common/UpFile.vue'
import Vue from 'vue'
import { fscDate } from '../../../static/mixins/fastChooseDate'
export default {
  name: 'HeadBg',
  mixins: [fscDate],
  components: { upfile, HeadPic },
  data() {
    Vue.directive('down', {
      inserted: (el, binding) => {
        el.style.cssText = 'cursor: pointer;color:write;'
        el.addEventListener('click', () => {
          // console.log(binding.value)
          let link = document.createElement('a')
          let image = document.createElement('image')
          let url = binding.value
          let downloadName = url.slice(url.lastIndexOf('/') + 1)
          // console.log(downloadName);
          // 这里是将url转成blob地址，
          image.setAttribute('crossOrigin', 'anonymous') // 这句可以解决跨域问题
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob)
              // console.log(link.href)
              link.download = downloadName
              document.body.appendChild(link)
              link.click()
            })
        })
      },
    })
    let checkPhone = (rule, value, callback) => {
      if (value !== '') {
        let reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输⼊有效的⼿机号码'))
        }
      }
      callback()
    }
    let numReg = /^[0-9]*$/
    let numRe = new RegExp(numReg)
    let checkDuration = (rule, value, callback) => {
      if (value.length > 0) {
        if (!numRe.test(value)) {
          return callback(new Error('请输入数字！'))
        }
      }
      callback()
    }
    return {
      list_edit: [],
      list_edit_cate: [],
      doEditInputId_cate: '',
      toEdit: [],
      doEditInputId: '',
      doEditInputId_cate_id: '',
      timer_edit_body: '',
      timer_edit_cate: '',
      toEdit_cate: [],
      phoneFrom_phone: [],
      phoneFromDraw: false,
      timer: '',
      timer_sort: '',
      needType: '',
      companyComId: null,
      companyInfoDrawer: false,
      unMatterOveredId: '',
      pageSize_un: 10,
      total_un: 0,
      npage_un: 1,
      unMatterOveredData: [],
      unMatterOveredDrawer: false,
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      change: false,
      aboutExId: '',
      FOptions: [],
      needUrl: [],
      fileList: [],
      limit: 10,
      distributeForm: {
        feedback: '',
        progress: '1',
      },
      examineFeed: {
        remark: '',
      },
      distributeDrawer: false,
      exmined: [],
      examine: [],
      examineId: '',
      needId: '',
      examineDialog: false,
      pageSize_inside: 10,
      nowPage_inside: 1,
      total_inside: 0,
      npage_inside: 1,
      examineData: [],
      searchArr: {
        phone_order: '',
        created_at: '',
        send_pay_date: '',
      },
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      branch: [],
      options_adminUsers: [],
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        },
      },
      categoryForm: {
        sort: '',
        display: false,
        body: '',
        name: '',
        phone: '',
        branch_id: '',
        station: '',
        meetAt: '',
        meet_place: '',
        feishuurl: '',
      },
      editCategoryForm: {
        categoryId: '',
        category_name: '',
        display: false,
      },
      itemCate_options: [],
      addAddressForm: {
        addressee: '',
        address_phone: '',
        address: '',
      },
      addressRules: {
        addressee: [
          { required: true, message: '请输入分类', trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
        address_phone: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' },
        ],
      },
      rules: {
        name: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        sort: [{ validator: checkDuration, trigger: 'blur' }],
        body: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        meetAt: [
          { required: true, message: '请选择面试时间', trigger: 'blur' },
        ],
        meet_place: [
          { required: true, message: '请选择面试地点', trigger: 'blur' },
        ],
        station: [
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        feishuurl: [
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
  },
  mounted() {
    this.loadTable()
    this.$bus.$on('ysy_head_bg', (needUrl) => {
      this.loadTable()
    })
    this.$bus.$on('ysy_pictureItem_refresh', () => {
      this.loadTable()
    })
    this.$bus.$on('ysy_head_bg_err', (messgae) => {
      this.$message.error(messgae)
    })
  },
  beforeDestroy() {
    this.$bus.$off('ysy_head_bg')
    this.$bus.$off('ysy_pictureItem_refresh')
    this.$bus.$off('ysy_head_bg_err')
  },
  watch: {
    'searchArr.phone_order': {
      handler() {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.npage = 1
          this.loadTable()
        }, 300)
      },
      deep: true,
    },
    categoryData(n) {
      n.forEach((item) => {
        if (item.display === 2) {
          this.ListIfDisplay[item.id] = true
        }
        this.listSort[item.id] = item.sort
      })
    },
    listSort: {
      handler(n) {
        if (this.timer_sort) {
          clearTimeout(this.timer_sort)
        }
        this.timer_sort = setTimeout(() => {
          this.$nextTick(() => {
            this.editListSortC(n)
          })
        }, 600)
      },
      deep: true,
    },
    list_edit: {
      handler(n) {
        if (this.timer_edit_body) {
          clearTimeout(this.timer_edit_body)
        }
        this.timer_edit_body = setTimeout(() => {
          this.$nextTick(() => {
            this.doEditInput(n)
          })
        }, 500)
      },
      deep: true,
    },
    list_edit_cate: {
      handler(n) {
        if (this.timer_edit_cate) {
          clearTimeout(this.timer_edit_cate)
        }
        this.timer_edit_cate = setTimeout(() => {
          this.$nextTick(() => {
            this.doEditInputCate(n)
          })
        }, 500)
      },
      deep: true,
    },
  },
  methods: {
    doEditInput(name) {
      if (!name[this.doEditInputId]) {
        this.$message.warning('输入不能为空!')
        return false
      }
      this.$axios
        .put('api/single_item_edit_body', {
          name,
          id: this.doEditInputId,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.toEdit = []
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    doEditInputCate(name) {
      if (!name[this.doEditInputId_cate]) {
        this.$message.warning('输入不能为空!')
        return false
      }
      this.$axios
        .put('api/single_item_edit_cate', {
          id: this.doEditInputId_cate,
          name,
          cate_id: this.doEditInputId_cate_id,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.toEdit_cate = []
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    alert_edit_input(id, name) {
      this.doEditInputId = id
      this.toEdit = []
      this.toEdit.push(id)
      this.toEdit[id] = true
      this.list_edit[id] = name
      this.$nextTick(() => {
        this.$refs[`editinput${id}`].focus()
      })
    },
    alert_edit_input_cate(id, name, cate_id) {
      this.doEditInputId_cate = id
      this.doEditInputId_cate_id = cate_id
      this.toEdit_cate = []
      this.toEdit_cate.push(id)
      this.toEdit_cate[id] = true
      this.list_edit_cate[id] = name
      this.$nextTick(() => {
        this.$refs[`editinputcate${id}`].focus()
      })
    },
    editListRadioC(e, id) {
      this.$axios
        .put('api/single_item_edit_display', {
          e,
          id,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    editListSortC(val) {
      let numReg = /^[0-9]*$/
      let numRe = new RegExp(numReg)
      if (val[this.needId].length > 0) {
        if (!numRe.test(val[this.needId])) {
          this.$message.warning('请输入数字!')
          return false
        }
      }
      this.$axios
        .put('api/single_item_edit_sort', {
          val,
          id: this.needId,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$nextTick(() => {
              this.$refs[`list${this.needId}`].focus()
              this.$refs[`list${this.needId}`].blur()
            })
            this.$message.success(data.msg)
            this.loadTable()
          }
        })
        .catch()
    },
    saveChange(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post('api/single_item_add_cate', this.addAddressForm)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                let myEvent = new Event('click')
                document.dispatchEvent(myEvent)
                this.$message.success(data.msg)
                this.resetForm('addAddressForm')
                this.getItem_cate()
              } else {
                this.$message.error(data.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getItem_cate() {
      this.$axios
        .get('api/single_item_get_cate')
        .then(({ data }) => {
          if (data.code === 0) {
            this.itemCate_options = data.data
          }
        })
        .catch()
    },
    openUrl(url) {
      let newPage = this.$router.resolve({
        path: '/documentation',
        query: { url: url },
      })
      window.open(newPage.href, '_blank')
    },
    getAdminUser() {
      this.$axios.get('/api/admin/users').then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.options_adminUsers = data.data.users
          this.roles = data.data.roles
          this.statistical = data.data.statistical
        }
      })
    },
    getUser() {
      this.$axios.get('/api/admin/users').then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.users = data.data.users
          this.roles = data.data.roles
          this.branch = data.data.branch
          this.statistical = data.data.statistical
        }
      })
    },
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success',
      })
    },
    copySome(data) {
      this.copy(data)
    },
    handleSizeChange_un(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_un = val
      this.getUnMatterOveredData()
    },
    mounted(val) {
      this.npage_un = val
      this.getUnMatterOveredData()
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.id
      })
    },
    openCompanyCom_examine(row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.company_id
      })
    },
    closeUnMatterOveredDrawer() {
      this.unMatterOveredId = ''
      this.unMatterOveredData = []
    },
    getUnMatterOveredData() {
      if (!this.unMatterOveredId) return false
      this.$axios
        .get(
          'api/handover_examine/get_matter_un?page' +
          this.npage_un +
          '&perPage=' +
          this.pageSize_un +
          '&cid=' +
          this.unMatterOveredId
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.unMatterOveredData = data.data.data
            this.total_un = data.data.total
          }
        })
        .catch()
    },
    openUnMatterOvered(id) {
      this.unMatterOveredId = id
      this.getUnMatterOveredData()
      this.unMatterOveredDrawer = true
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / 1024 / 1024 < 100

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange(res, file) {
      this.fileList = file
      this.change = true
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name
    },
    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile()
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
    submitDisForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.distributeForm.file = this.needUrl
          this.distributeForm.id = this.aboutExId
          this.$axios
            .post('api/handover_examine/store', this.distributeForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.distributeDrawer = false
                this.$refs.distributeForm.resetFields()
                this.fileList = []
                this.needUrl = []
                this.change = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    handleSizeChange_inside(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_inside = val
      this.loadTable_inside()
    },
    handleCurrentChange_inside(val) {
      this.npage_inside = val
      this.loadTable_inside()
    },
    clearExamineParams() {
      let check = document.getElementsByTagName('input')
      let arr = Array.from(check)
      console.log(arr)
      arr.map((item) => {
        item.checked = false
      })
      // for (var i in this.examine) {
      //   this.examine[i] = false
      // }
      // this.examine.map((item, index) => {
      //   this.examine.splice(index, 1)
      // })
      this.examineId = ''
    },
    loadTable_inside() {
      this.$axios
        .get('api/handover_examine/' + this.examineId, {
          params: {
            page: this.npage_inside,
            perpage: this.pageSize_inside,
            // searchItem: this.searcher
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.examineData = data.data.data
            this.total_inside = data.data.total
            // this.loadRadio()
            // this.loadSort()
          }
        })
        .catch()
    },
    examineChange(val, id, index) {
      if (val) {
        this.$axios
          .put('api/handover_examine/' + this.examineId, {
            company_id: id,
          })
          .then(({ data }) => {
            if (data.code === 1) {
              // this.exmined.push(id)
              // this.examineData[index].is_examined = true
              this.loadTable_inside()
              this.loadTable()
              this.$message.success(data.msg)
              //   this.examineData = data.data.data
              //   this.total_inside = data.data.total
              // this.loadRadio()
              // this.loadSort()
            }
          })
          .catch()
      }
    },
    openNameRow(id) {
      this.examineId = id
      this.loadTable_inside()
      this.examineDialog = true
    },
    handleClick(val) {
      if (val.name === 'first') {
        this.npage = 1
        this.needType = ''
        this.loadTable()
      }
      if (val.name === 'second') {
        this.npage = 1
        this.needType = 1
        this.loadTable(1)
      }
      if (val.name === 'third') {
        this.needType = 0
        this.npage = 1
        this.loadTable(0)
      }
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone)
      })
      this.phoneFromDraw = true
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }
      // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
      this.$axios.post('api/admin/call_logs_call', {
        phone
      }).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = []
      done()
    },
    doSearch() {
      this.npage = 1
      this.loadTable(this.needType)
    },
    loadTable() {
      this.$axios
        .get('api/ysy_common_get_file_list', {
          params: {
            page: this.npage,
            per_page: this.categoryPerPage,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            setTimeout(() => {
              this.categoryData = data.data.data
            })
            this.total = data.data.total
            // this.loadRadio()
            // this.loadSort()
          }
        })
        .catch()
    },
    loadRadio() {
      this.categoryData.map((item) => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort() {
      this.categoryData.map((item) => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange(val) {
      this.npage = val
      this.loadTable(this.needType)
    },
    handleSizeChange(val) {
      this.categoryPerPage = val
      this.loadTable(this.needType)
    },
    editRow(id) {
      this.$axios
        .put('api/handover_examine/all_examined/' + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          }
        })
        .catch()
    },
    searchRemoteCfcategory(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem(query) {
      this.$axios
        .get('api/ysy_common_vague_search_bg', {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory() {
      setTimeout(() => {
        this.npage = 1
        this.loadTable()
      })
    },
    categoryIn() {
      this.categoryIndrawer = true
    },
    handleClose(done) {
      this.$refs.categoryForm.resetFields()
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.categoryForm.file = this.needUrl
          this.$axios
            .post('api/single_item_add_body', this.categoryForm)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.$refs.categoryForm.resetFields()
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put('api/advicecate/edit', {
              id: this.category,
              category_name: this.editCategoryForm.categoryId,
              display: this.ifDisplay === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio(row) {
      this.$axios
        .put('api/advicecate/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0,
        })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort(row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/advicecate/setsort', {
          id: row.id,
          sort: this.listSort[row.id],
        })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    handleCloseDis(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          if (this.$refs.distributeForm) {
            this.$refs.distributeForm.resetFields()
          }
          this.fileList = []
          this.needUrl = []
          this.change = false
          this.aboutExId = ''
          this.distributeForm.progress = 1
          this.FOptions = []
          done()
        })
        .catch((_) => { })
    },
    openExamineFeed(id) {
      this.aboutExId = id
      this.$axios
        .get('api/handover_examine/' + id + '/edit')
        .then(({ data }) => {
          if (data.code === 1) {
            this.FOptions = data.data
            let obj = data.data[0]
            this.distributeForm.progress = obj ? obj.progress : 1
          }
        })
        .catch()
      this.distributeDrawer = true
    },
  },
}
</script>
<style scoped>
.handover_examine {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

#forStyle>>>.demo-table-expand {
  font-size: 0;
}

#forStyle>>>.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

#forStyle>>>.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/miniProQiYeHuoConfig/HeadBg.vue